export const AppRoutes = {
  // Auth (login handled by irohana-center via SSO; /login is only a bridge that forwards to center)
  login: "/login",
  logout: "/logout",
  authCallback: "/auth/callback",

  // Home
  home: "/",

  // RSO Management
  duringContractList: "/rso/during-contract",
  canceledContractList: "/rso/canceled-contract",
  trialRsoList: "/rso/trial",
  trialCancelledList: "/rso/trial-cancelled",
  rsoCreate: "/rso/create",
  rsoDetail: "/rso/:id/detail",
  rsoEdit: "/rso/:id/edit",
  rsoUserCreate: "/rso/:id/user/create",
  rsoUserEdit: "/rso/:id/user/:userId/edit",

  // Organization Management
  organizationList: "/organization",
  organizationCreate: "/organization/create",
  organizationDetail: "/organization/:id/detail",
  organizationEdit: "/organization/:id/edit",

  // information
  information: "/information",
  informationCreate: "/information/create",
  informationEdit: "/information/:id/edit",

  // Convert
  convert: "/convert",
  convertHistory: "/convert/history",
  convertDetail: "/convert/:id",

  // Master data
  masterData: "/master-data",
  masterDataDetail: "/master-data/:type",

  // System setting
  emailSetting: "/email-setting",
  maintenanceSetting: "/maintenance-setting",

  // page not found
  pageNotFound: "/page-not-found",
  serverErrorPage: "/server-error",

  // Chat
  chat: "/chat",
  chatDetail: "/chat/:id",
};

export const OrganizationManagementRoutes = [
  AppRoutes.organizationList,
  AppRoutes.organizationCreate,
  AppRoutes.organizationDetail,
  AppRoutes.organizationEdit,
];

export const InformationRoutes = [AppRoutes.information, AppRoutes.informationCreate, AppRoutes.informationEdit];

export const ConvertRoutes = [AppRoutes.convert, AppRoutes.convertHistory, AppRoutes.convertDetail];

export const MasterDataRoutes = [AppRoutes.masterData, AppRoutes.masterDataDetail];

export const SystemSettingRoutes = [AppRoutes.emailSetting, AppRoutes.maintenanceSetting];

export const ChatRoutes = [AppRoutes.chat, AppRoutes.chatDetail];

export const AdminRoutes = [
  AppRoutes.home,
  OrganizationManagementRoutes,
  InformationRoutes,
  SystemSettingRoutes,
  ChatRoutes,
  ConvertRoutes,
  MasterDataRoutes,
].flat();
